
import { Box } from '@chakra-ui/react';
import { IField } from '../../interfaces/IField';

const StaticText = ({ name, label }: IField) => {

  return (
    <Box
      id={name}
      w='full'
      mt={2}
      mb={1}
      dangerouslySetInnerHTML={{ __html: label || '' }}
    />
  );
};

export default StaticText;
